var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "eight wide column"
  }, [_c('table', {
    staticClass: "ui small very basic very compact center aligned table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.sfrs), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.sfr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.toHex(item.value)))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "eight wide column"
  }, [_c('table', {
    staticClass: "ui small very basic very compact center aligned table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.memory.ram.slice(0, 128)), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.toHex(index)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.toHex(item)))])])
  }))])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("SFR")]), _vm._v(" "), _c('th', [_vm._v("Value")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Value")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7de40f6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Memory.vue
// module id = 92
// module chunks = 1